// extracted by mini-css-extract-plugin
module.exports = {"footer":"Form-module__footer--1Gj2u","loading":"Form-module__loading--3ihWF","uploadArea":"Form-module__uploadArea--1StDK","uploadText":"Form-module__uploadText--3cKxR"};